<template>
  <el-form class="page-search" inline>
    <el-form-item label="DSN">
      <el-input v-model="search.data.dsn" size="small" clearable />
    </el-form-item>

    <el-form-item label="注册邮箱">
      <el-input
        v-model="search.data.amazon_register_mail"
        size="small"
        clearable
      />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" size="small" @click="onSubmit">
        查询
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import store from './device-kindle.store'

export default {
  data() {
    return {
      search: store.search
    }
  },

  methods: {
    onSubmit() {
      store.fetch(true)
    }
  }
}
</script>
